import { ChainSymbols } from "based-auth/chains";
import { ethABI01, solABI01 } from "./assets";
import { NetworkSymbols } from "based-auth/networks";

export const isMainnet = process.env.NEXT_PUBLIC_APP_ENV === "mainnet";

export const currencies = {
  native: "native",
  usd: "usd",
};

export const maxUint8 = 2n ** 8n - 1n;
export const maxUint24 = 2n ** 24n - 1n;
export const maxUint64 = 2n ** 64n - 1n;
export const maxUint40 = 2n ** 40n - 1n;

export const ITEMS_PER_PAGE = 12;
export const CONTENT_HASH_ALGORITHM = "sha256";

export const IPFS_PARAMETER_LIMIT = 10;
export const IPFS_SIZE_LIMIT = "1500kb";

export const SUB_BOARD_TITLE_LIMIT = 10;
export const LOGO_SIZE = 128;
export const SEO_IMAGE_SIZE = 1024;
export const BANNER_WIDTH = 900;
export const BANNER_HEIGHT = 200;
export const LOGO_FILE_LIMIT = 1024 ** 2;
export const BANNER_FILE_LIMIT = 3 * 1024 ** 2;

export const PERCENT_DECIMALS = 4;
export const NATIVE_PRICE_DECIMALS = 9;

export const HOT_PERCENT = "85";

export const DESCRIPTION_LIMIT = 2500;

export const FIFTEEN_MINUTES = 15 * 60 * 1000;
export const ONE_DAY = 24 * 3600_000;

export const SEED_LENGTH = 25;
export const COPIED_TIEMOUT = 800;

export const CDN_URL =
  process.env.NEXT_PUBLIC_CDN || "https://cdn.basedbid.com";

export const ORIGINAL_IPFS_URL = "https://ipfs.io/ipfs";
export const IPFS_URI =
  process.env.NEXT_PUBLIC_IPFS_GETWAY ||
  "https://won-finger-heart.quicknode-ipfs.com/ipfs";

export const PATH_IPFS = process.env.PATH_IPFS || "/ipfs";

export const HOST_URL =
  process.env.NEXT_PUBLIC_DOMAIN || "https://basedbid.com";

export const SOCKET_URL = process.env.NEXT_PUBLIC_SOCKET_URL || "/";
export const WAIT_FOR_RPC = Number(process.env.WAIT_FOR_RPC || 2000);

export const allowedDomains = [
  "http://localhost:3000",
  "https://basedbid.com",
  "https://www.basedbid.com",
  "https://testnet.basedbid.com",
  "https://devnet.basedbid.com",
];

export const tokenMetadataProgramAddress =
  "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s";

export const wSolMintAddress = "So11111111111111111111111111111111111111112";

export const adminAddresses = {
  [ChainSymbols.eth]: "0xcb98eafa8aCF87545c6773748d256eBFf7B0a128",
  [ChainSymbols.solDevnet]: "A9CwtR7VWSYKNxAD19smWMWNshJooGLMWS81jd5h8KWL",
  [ChainSymbols.sol]: "",
  [ChainSymbols.bsc]: "",
  [ChainSymbols.tbsc]: "",
  [ChainSymbols.sui]: "",
  [ChainSymbols.suiDevnet]: "",
  [ChainSymbols.ton]: "",
  [ChainSymbols.tonDevnet]: "",
  [ChainSymbols.base]: "",
  [ChainSymbols.uni]: "",
};

export const KEEP_ALIVE_INTERVAL = {
  [ChainSymbols.tbsc]: 3000,
  [ChainSymbols.solDevnet]: 1000,
  [ChainSymbols.eth]: 12000,
  [ChainSymbols.sol]: 1000,
  [ChainSymbols.base]: 2000,
  [ChainSymbols.uni]: 14000,
  [ChainSymbols.bsc]: 3000,
  [ChainSymbols.ton]: 5000,
  [ChainSymbols.tonDevnet]: 5000,
  [ChainSymbols.sui]: 1000,
  [ChainSymbols.suiDevnet]: 1000,
};

export const stateValues = {
  stopStatusAccount: "9VVKh47HG62wcWhUiFB8XRD36z52xHpu99ASCJHESi8n",
  lock: "HMpEqW77cgeRuH6unUGBfP6RyoeiLgbYeHCAtqa3ksjA",
  tokenAccountSeed: "token_account",
  platformSeed: "platform",
  metadataSeed: "metadata",
  buyerSeed: "buyer",
  tokenSeed: "token",
  mintSeed: "mint",
  wSolMint: "So11111111111111111111111111111111111111112",
  metadataProgramId: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
};

export const constValues: {
  [key: string]: {
    maxUint: bigint;
    zeroAddress: string;
    functionNames: Record<string, string>;
  };
} = {
  [NetworkSymbols.eth]: {
    maxUint: 2n ** 256n - 1n,
    zeroAddress: "0x0000000000000000000000000000000000000000",
    functionNames: {
      createSimpleMeme: "createSimpleMeme",
      createMeme: "createMeme",
      getAmountOutETH: "getAmountOutETH",
      getAmountOutTokens: "getAmountOutTokens",
      updateWhitelistForMemeToken: "updateWhitelistForMemeToken",
      applySubBoard: "applySubBoard",
      updateSubBoardMetaData: "updateSubBoardMetaData",
      updateSubBoardFee: "updateSubBoardFee",
    },
  },
  [NetworkSymbols.sol]: {
    maxUint: 2n ** 64n - 1n,
    zeroAddress: "11111111111111111111111111111111",
    functionNames: {
      createSimpleMeme: "createSimpleMeme",
      createMeme: "createMeme",
      getAmountOutETH: "getAmountOutSol",
      getAmountOutTokens: "getAmountOutTokens",
      updateWhitelistForMemeToken: "updateWhitelistForMemeToken",
      applySubBoard: "applySubBoard",
      updateSubBoardMetaData: "updateSubBoardMetaData",
      updateSubBoardFee: "updateSubBoardFee",
    },
  },
};

export const solAccounts: Record<
  ChainSymbols.sol | ChainSymbols.solDevnet,
  {
    appStorage: string;
    admin: string;
    raydiumV5: string;
    raydiumFee: string;
  }
> = {
  [ChainSymbols.sol]: {
    appStorage: "",
    admin: adminAddresses[ChainSymbols.sol],
    raydiumV5: "CPMMoo8L3F4NbTegBCKVNunggL7H1ZpdTHKxQB5qKP1C",
    raydiumFee: "DNXgeM9EiiaAbaWvwjHj9fQQLAX5ZsfHyvmYUNRAdNC8",
  },
  [ChainSymbols.solDevnet]: {
    appStorage: "735eZhxFGoS37r7d8qjnfEvVS18uyZdCa7GBEnHePe9H",
    admin: adminAddresses[ChainSymbols.solDevnet],
    raydiumV5: "CPMDWBwJDtYax9qW7AyRuVC19Cc4L4Vcy4n2BHAbHkCW",
    raydiumFee: "G11FKBRaAkHAKuLCgLM6K6NUc9rTjPAznRCjZifrTQe2",
  },
};

export const contractInfo: Record<
  ChainSymbols,
  {
    address: string;
    versions: { abi: any; block: number }[];
  }
> = {
  [ChainSymbols.tbsc]: {
    address: "0x96c37708fADAE2FCad8c333cB84C7c858E1dc01f",
    versions: [
      {
        abi: ethABI01,
        block: 59042092,
      },
    ],
  },
  [ChainSymbols.solDevnet]: {
    address: "3M3VLQ5FCjn1A7s1nhoniNYPEhFp9zCZBE32FLV6eyf2",
    versions: [
      {
        abi: solABI01,
        block: 396243830,
      },
    ],
  },
  [ChainSymbols.sol]: {
    address: "3M3VLQ5FCjn1A7s1nhoniNYPEhFp9zCZBE32FLV6eyf2",
    versions: [],
  },
  [ChainSymbols.eth]: { address: "", versions: [] },
  [ChainSymbols.uni]: { address: "", versions: [] },
  [ChainSymbols.base]: { address: "", versions: [] },
  [ChainSymbols.bsc]: { address: "", versions: [] },
  [ChainSymbols.sui]: { address: "", versions: [] },
  [ChainSymbols.suiDevnet]: { address: "", versions: [] },
  [ChainSymbols.ton]: { address: "", versions: [] },
  [ChainSymbols.tonDevnet]: { address: "", versions: [] },
};

export const rpcs = {
  [ChainSymbols.tbsc]: [
    {
      url: "wss://bsc-testnet.blockpi.network/v1/ws/cd61e00aed93674ae0d608f823e2c2d05a52752d",
      block: 5000,
    },
  ],
  [ChainSymbols.bsc]: [
    {
      url: "wss://hidden-proportionate-aura.bsc.quiknode.pro/fc68f3fa6402d7c442f8e91f12c21de2c953d38e/",
      block: 500000,
    },
    {
      url: "wss://bsc.blockpi.network/v1/ws/44ee6379a352148c518c452e9ab05ff9db820294",
      block: 500000,
    },
  ],
  [ChainSymbols.eth]: [
    {
      url: "wss://little-broken-darkness.quiknode.pro/f85e866a4c8f0f3efa7c7bf0ec13e7fbca89a53c/",
      block: 500000,
    },
    {
      url: "wss://yolo-weathered-seed.quiknode.pro/4cb47a5c576555d953130952142ce72d72ab3feb/",
      block: 500000,
    },
    {
      url: "wss://ethereum.blockpi.network/v1/ws/7d5ca4a66a7ee2c83665faeff88e28b900b8e13b",
      block: 500000,
    },
  ],
  [ChainSymbols.base]: [
    {
      url: "wss://newest-autumn-friday.base-mainnet.quiknode.pro/04f163456de87269c6223cfe09df05b682c1cbe8/",
      block: 500000,
    },
    {
      url: "wss://fabled-special-wish.base-mainnet.quiknode.pro/6a79b883b4d8ea93ecd86acaf4b1d3a3eeaf5480/",
      block: 500000,
    },
    {
      url: "wss://base.blockpi.network/v1/ws/e7c7b85c7b5b718e6916e5e9017a51795f333e24",
      block: 500000,
    },
  ],
  [ChainSymbols.uni]: [
    {
      url: "wss://unichain-sepolia.blockpi.network/v1/ws/7a76de3edb42d4fe3af8e70eb09fc040b858c91d",
      block: 500000,
    },
  ],
  [ChainSymbols.sui]: [
    {
      url: "wss://sui.blockpi.network/v1/ws/4f4fdc33254600c03ca59e0f4b4ed615dbf58938",
      block: 500000,
    },
  ],
  [ChainSymbols.solDevnet]: [
    {
      url: "https://solana-devnet.core.chainstack.com/0083ce65be7bc1b5beac2efba5be3c7b",
      block: 1000,
    },
  ],
  [ChainSymbols.sol]: [
    {
      url: "https://late-indulgent-surf.solana-mainnet.quiknode.pro/06bfbf9317a2dac06f06abf1087a9ea64cd0da56/",
      block: 1000,
    },
    {
      url: "https://shy-omniscient-breeze.solana-mainnet.quiknode.pro/faf344b6f231bee3540b30de516ae70826cbe150",
      block: 1000,
    },
  ],
  [ChainSymbols.suiDevnet]: [],
  [ChainSymbols.ton]: [],
  [ChainSymbols.tonDevnet]: [],
};

export const RAISE_TOKENS = {
  [ChainSymbols.tbsc]: [
    {
      address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
      symbol: "BNB",
      decimals: 18,
    },
    {
      address: "0x8301F2213c0eeD49a7E28Ae4c3e91722919B8B47",
      symbol: "USDT",
      decimals: 18,
    },
  ],
  [ChainSymbols.eth]: [
    {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "ETH",
      decimals: 18,
    },
    {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
      decimals: 6,
    },
  ],
  [ChainSymbols.bsc]: [
    {
      address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
      symbol: "BNB",
      decimals: 18,
    },
    {
      address: "0x55d398326f99059fF775485246999027B3197955",
      symbol: "USDT",
      decimals: 18,
    },
  ],
  [ChainSymbols.uni]: [
    {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "ETH",
      decimals: 18,
    },
    {
      address: "0x078D782b760474a361dDA0AF3839290b0EF57AD6",
      symbol: "USDC",
      decimals: 6,
    },
  ],
  [ChainSymbols.base]: [
    {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "ETH",
      decimals: 18,
    },
    {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
      decimals: 6,
    },
  ],
  [ChainSymbols.solDevnet]: [
    {
      address: wSolMintAddress,
      symbol: "SOL",
      decimals: 9,
    },
    {
      address: "Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr",
      symbol: "USDC",
      decimals: 9,
    },
  ],
  [ChainSymbols.sol]: [
    {
      address: "So11111111111111111111111111111111111111112",
      symbol: "SOL",
      decimals: 9,
    },
    {
      address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
      symbol: "USDC",
      decimals: 9,
    },
  ],
};

export const SWAP_ROUTERS = {
  [ChainSymbols.tbsc]: [
    {
      id: "pancakeswap",
      label: "PancakeSwap",
      url: "https://pancakeswap.finance/swap?chain=bscTestnet&outputCurrency=",
      v2: {
        router: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
        factory: "0x6725F303b657a9451d8BA641348b6761A6CC7a17",
      },
      v3: {
        positionManager: "0x427bF5b37357632377eCbEC9de3626C71A5396c1",
        router: "0x9a489505a00cE272eAa5e07Dba6491314CaE3796",
        factory: "0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865",
        fee: [100, 500, 2500, 10000],
      },
    },
  ],
  [ChainSymbols.eth]: [
    {
      id: "uniswap",
      label: "UniSwap",
      url: "https://app.uniswap.org/#/swap?outputCurrency=",
      v2: {
        router: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
        factory: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
      },
      v3: {
        positionManager: "0xC36442b4a4522E871399CD717aBDD847Ab11FE88",
        router: "0xE592427A0AEce92De3Edee1F18E0157C05861564",
        factory: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
        fee: [100, 500, 3000, 10000],
      },
    },
    {
      id: "pancakeswap",
      label: "PancakeSwap",
      url: "https://pancakeswap.finance/swap?outputCurrency=",
      v2: {
        router: "0xEfF92A263d31888d860bD50809A8D171709b7b1c",
        factory: "0x1097053Fd2ea711dad45caCcc45EfF7548fCB362",
      },
      v3: {
        positionManager: "0x46A15B0b27311cedF172AB29E4f4766fbE7F4364",
        router: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
        factory: "0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865",
        fee: [100, 500, 2500, 10000],
      },
    },
  ],
  [ChainSymbols.bsc]: [
    {
      id: "pancakeswap",
      label: "PancakeSwap",
      url: "https://pancakeswap.finance/swap?outputCurrency=",
      v2: {
        router: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        factory: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
      },
      v3: {
        positionManager: "0x46A15B0b27311cedF172AB29E4f4766fbE7F4364",
        router: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
        factory: "0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865",
        fee: [100, 500, 2500, 10000],
      },
    },
    {
      id: "uniswap",
      label: "UniSwap",
      url: "https://app.uniswap.org/#/swap?outputCurrency=",
      v2: {
        router: "0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24",
        factory: "0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6",
      },
      v3: {
        positionManager: "0x7b8A01B39D58278b5DE7e48c8449c9f4F5170613",
        router: "0x7b8A01B39D58278b5DE7e48c8449c9f4F5170613",
        factory: "0xdB1d10011AD0Ff90774D0C6Bb92e5C5c8b4461F7",
        fee: [100, 500, 3000, 10000],
      },
    },
    {
      id: "howswap",
      label: "HowSwap",
      url: "https://howswap.com/swap?outputCurrency=",
      v2: {
        router: "0x84dfe8dA2c41e8d536748Bc0195D7fE6A39D3fae",
        factory: "0xF4866c04a88Cb593374865D73D7cF5B5B3A9c641",
      },
    },
    {
      id: "melegaswap",
      label: "MelegaSwap",
      url: "https://melega.finance/swap?outputCurrency=",
      v2: {
        router: "0xc25033218D181b27D4a2944Fbb04FC055da4EAB3",
        factory: "0xb7E5848e1d0CB457f2026670fCb9BbdB7e9E039C",
      },
    },
    {
      id: "apeswap",
      label: "Apeswap",
      url: "https://apeswap.finance/swap?outputCurrency=",
      v2: {
        router: "0xcF0feBd3f17CEf5b47b0cD257aCf6025c5BFf3b7",
        factory: "0x0841BD0B734E4F5853f0dD8d7Ea041c241fb0Da6",
      },
    },
    {
      id: "babydogeswap",
      label: "Babydogeswap",
      url: "https://babydogeswap.com/swap?outputCurrency=",
      v2: {
        router: "0xC9a0F685F39d05D835c369036251ee3aEaaF3c47",
        factory: "0x4693B62E5fc9c0a45F89D62e6300a03C85f43137",
      },
    },
  ],
  [ChainSymbols.base]: [
    {
      id: "uniswap",
      label: "UniSwap",
      url: "https://app.uniswap.org/#/swap?outputCurrency=",
      v2: {
        router: "0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24",
        factory: "0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6",
      },
      v3: {
        positionManager: "0x03a520b32C04BF3bEEf7BEb72E919cf822Ed34f1",
        router: "0x03a520b32C04BF3bEEf7BEb72E919cf822Ed34f1",
        factory: "0x33128a8fC17869897dcE68Ed026d694621f6FDfD",
        fee: [100, 500, 3000, 10000],
      },
    },
    {
      id: "pancakeswap",
      label: "PancakeSwap",
      url: "https://pancakeswap.finance/swap?chain=base&outputCurrency=",
      v2: {
        router: "0x8cFe327CEc66d1C090Dd72bd0FF11d690C33a2Eb",
        factory: "0x02a84c1b3BBD7401a5f7fa98a384EBC70bB5749E",
      },
    },
  ],
  [ChainSymbols.uni]: [
    {
      id: "uniswap",
      label: "UniSwap",
      url: "https://app.uniswap.org/#/swap?outputCurrency=",
      v2: {
        router: "0x284F11109359a7e1306C3e447ef14D38400063FF",
        factory: "0x1F98400000000000000000000000000000000002",
      },
      v3: {
        positionManager: "0x943e6e07a7E8E791dAFC44083e54041D743C46E9",
        router: "0x73855d06DE49d0fe4A9c42636Ba96c62da12FF9C",
        factory: "0x1F98400000000000000000000000000000000003",
        fee: [100, 500, 3000, 10000],
      },
    },
  ],
  [ChainSymbols.sol]: [
    {
      id: "raydium",
      label: "Raydium",
      url: "https://raydium.io/swap/?inputMint=sol&outputMint=",
      v3: {
        router: solAccounts[ChainSymbols.sol].raydiumV5,
      },
    },
  ],
  [ChainSymbols.solDevnet]: [
    {
      id: "raydium",
      label: "Raydium",
      url: "https://raydium.io/swap/?inputMint=sol&outputMint=",
      v3: {
        router: solAccounts[ChainSymbols.solDevnet].raydiumV5,
      },
    },
  ],
};
